import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';

// Replaces the library header: its year select lists the years oldest first
// and cannot be reordered or resized.
const DobCalendarHeader = ({
  changeMonth,
  changeYear,
  date,
  decreaseMonth,
  increaseMonth,
  monthNames,
  nextMonthButtonDisabled,
  prevMonthButtonDisabled,
  years,
}) => (
  <div className="nawi-chat__dob-header">
    <button
      aria-label={I18n.t('persons.nawiChat.dobRequired.previousMonth')}
      className="nawi-chat__dob-nav"
      disabled={prevMonthButtonDisabled}
      onClick={decreaseMonth}
      type="button"
    >
      ‹
    </button>
    <select
      aria-label={I18n.t('persons.nawiChat.dobRequired.month')}
      className="nawi-chat__dob-month"
      onChange={(event) => changeMonth(Number(event.target.value))}
      value={date.getMonth()}
    >
      {monthNames.map((name, month) => (
        <option key={name} value={month}>
          {name}
        </option>
      ))}
    </select>
    <select
      aria-label={I18n.t('persons.nawiChat.dobRequired.year')}
      className="nawi-chat__dob-year"
      onChange={(event) => changeYear(Number(event.target.value))}
      value={date.getFullYear()}
    >
      {years.map((year) => (
        <option key={year} value={year}>
          {year}
        </option>
      ))}
    </select>
    <button
      aria-label={I18n.t('persons.nawiChat.dobRequired.nextMonth')}
      className="nawi-chat__dob-nav"
      disabled={nextMonthButtonDisabled}
      onClick={increaseMonth}
      type="button"
    >
      ›
    </button>
  </div>
);

DobCalendarHeader.propTypes = {
  changeMonth: PropTypes.func.isRequired,
  changeYear: PropTypes.func.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  decreaseMonth: PropTypes.func.isRequired,
  increaseMonth: PropTypes.func.isRequired,
  monthNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  nextMonthButtonDisabled: PropTypes.bool,
  prevMonthButtonDisabled: PropTypes.bool,
  years: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default DobCalendarHeader;
